import React, {useState} from 'react'
export default function ABC(){
  const [DEF, setDEF] = useState('')
  const [ABC, setABC] = useState('')
  const [GHI, setGHI] = useState('')
  const [JKL, setJKL] = useState('')
  const PQR = (e) => {
    e.preventDefault()
    setDEF(e.target.files[0])
  }
  const MNO = (e) => {
    e.preventDefault()
    setGHI('')
    setJKL('')
    let STU = e.target.files[0].size
    //Show error 
    if (STU >= (1024 * 10000) ){
      setJKL(`File has to be less than 10MB. Uploaded file size: ${Math.round((STU / 1024 ** 2)*100)/100}MB`)
    //Show in MB
    } else if (Math.round((STU / 1024 ** 2)*100)/100 >= 1 ){
      setGHI(`File is successfully uploaded. Uploaded file size: ${Math.round((STU / 1024 ** 2)*100)/100}MB`)
      setABC(e.target.files[0])
      setDEF(URL.createObjectURL(e.target.files[0]))
    //Show in KB
    }else{
      setGHI(`File is successfully uploaded. Uploaded file size: ${Math.round(STU/1024)}KB`)
      setABC(e.target.files[0])
      setDEF(URL.createObjectURL(e.target.files[0]))
    }
  }
  return (
    <div>
    <div className='text-xs mb-2'>
       · png, jpeg, jpg, gif only<br/>
       · file limit 10MB</div>
    {ABC!=''?<div className='mb-1 text-xs'>
    <img src={DEF} className='border border-gray-900 w-[150px]'/>
    File Name: {ABC.name}<br/>
    File Size: {Math.round(ABC.size / 1024)}KB<br/>
    File Type: {ABC.type}<br/>
    </div>:''}
    <form className='flex-col flex' onSubmit={PQR}>
    <label for='file17' style={{padding:'5px 14px'}} className='secondary-btn w-fit mr-1 font-bold'>Upload Image</label>
    <input 
      id='file17'
      type='file' 
      accept='image/png, image/jpeg, image/jpg, image/gif' 
      single
      hidden
      onChange={MNO} 
      />
    {GHI!='' ? <span className='text-xs'>{GHI}</span>:''}
    {JKL!='' ? <span className='text-red-800 text-[9px]'>{JKL}</span>:''}
    </form>
    </div>
  )
}